import React, { useState } from 'react';
import { Dialog, Button, IconButton, useMediaQuery } from '@mui/material';
import { CloseRounded, ArrowForwardRounded, InsightsRounded, TouchAppRounded, DashboardRounded } from '@mui/icons-material';
import { authService } from '../../services/api';
import './SpringAnnouncement.css';

const seenInMemory = new Set();
const assets = `${process.env.PUBLIC_URL || ''}/releases/spring-0926`;
function userKey() {
  try {
    if (!authService.isAuthenticated()) return null;
    const user = authService.getCurrentUser();
    const id = user?.idUser ?? user?.usuario;
    return id == null ? null : `integra:release:0926-spring:${encodeURIComponent(String(id))}`;
  } catch { return null; }
}
function wasSeen(key) {
  if (!key || seenInMemory.has(key)) return true;
  try { return localStorage.getItem(key) === 'seen'; } catch { return false; }
}

export default function SpringAnnouncement() {
  const [key] = useState(userKey);
  const [open, setOpen] = useState(() => !wasSeen(key));
  const [details, setDetails] = useState(false);
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const markSeen = () => {
    if (!key) return;
    seenInMemory.add(key);
    try { localStorage.setItem(key, 'seen'); } catch { /* Keep the session usable if storage is unavailable. */ }
  };
  const close = () => { markSeen(); setOpen(false); };
  return <Dialog open={open} onClose={close} maxWidth={false}
    aria-labelledby="spring-title" aria-describedby="spring-description"
    transitionDuration={reducedMotion ? 0 : 350} TransitionProps={{ onEntered: markSeen }}
    PaperProps={{ className: 'spring-announcement' }}
    sx={{ zIndex: 150000, '& .MuiBackdrop-root': { backgroundColor: 'rgba(17,23,20,.62)', backdropFilter: 'blur(8px)' } }}>
    <div className={`spring-scene${details ? ' spring-scene--details' : ''}`}>
      <img className="spring-forest" src={`${assets}/forest.jpg`} alt="" />
      <div className="spring-shade" />
      <IconButton className="spring-close" aria-label="Cerrar novedades de Spring" onClick={close}><CloseRounded /></IconButton>
      <div className="spring-content">
        <span className="spring-edition"><span /> NUEVA ACTUALIZACIÓN <span className="spring-edition-divider">/</span> DLC 0926</span>
        <h2 id="spring-title" className="spring-title"><span className="spring-sr-only">Spring</span><img src={`${assets}/spring.png`} alt="" /></h2>
        <p className="spring-tagline">Una nueva temporada.<br />Una experiencia renovada.</p>
        <p id="spring-description" className="spring-description">Más claridad, más armonía y una nueva forma de disfrutar Integra. Todo florece en los detalles.</p>
        {!details && <Button disableRipple className="spring-primary" onClick={() => { markSeen(); setDetails(true); }} endIcon={<ArrowForwardRounded />}>Ver ahora</Button>}
      </div>
    </div>
    {details ? <section className="spring-news" aria-label="Novedades de Spring">
      <div className="spring-news-heading"><span>LO NUEVO EN SPRING</span><h3>Pequeños detalles. Una gran diferencia.</h3></div>
      <div className="spring-features">
        {[{ Icon: DashboardRounded, title: 'Un espacio más tuyo', text: 'Menús renovados, nuevos iconos y una navegación más clara.' },
          { Icon: InsightsRounded, title: 'Datos que se entienden', text: 'Indicadores con gráficos suaves y una mejor distribución de la información.' },
          { Icon: TouchAppRounded, title: 'Cada detalle cuenta', text: 'Controles, pestañas y tablas más uniformes, también en móvil y tablet.' }].map(({ Icon, title, text }) => <article key={title}><span className="spring-feature-icon"><Icon /></span><h4>{title}</h4><p>{text}</p></article>)}
      </div>
      <Button disableRipple autoFocus className="spring-continue" onClick={close} endIcon={<ArrowForwardRounded />}>Empezar a explorar</Button>
    </section> : <div className="spring-footer"><div className="spring-signature"><img src={`${process.env.PUBLIC_URL || ''}/Imagenes/logo-ardata.png`} alt="Ardata" /><span>Un bit a la vez.</span></div></div>}
  </Dialog>;
}

